import styled from "styled-components";

export const StyledContainer = styled("div")`
  display:flex;
  flex-direction:column;
  text-align: center;
  justify-content: center;
  align-items: center;
`;


export const UploadContainer = styled("div")`
  display:flex;
  flex-direction:row;
  text-align: center;
  justify-content: center;
  align-items: center;
`;

export const DocumentContainer = styled("div")`
  margin-top:30px;
`;
